import React from "react";
import { motion } from "framer-motion";
import { Code2, GraduationCap, Sparkles, Users, Check } from "lucide-react";
import { SERVICES } from "../data/content";

const ICONS = {
    Code2: Code2,
    GraduationCap: GraduationCap,
    Sparkles: Sparkles,
    Users: Users,
};

const Services = () => {
    return (
        <section id="services" className="relative py-24 lg:py-32 bg-graphite/30" data-testid="services">
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
                    <div className="lg:col-span-7">
                        <div className="pill"><span className="accent-dot" />What we deliver</div>
                        <h2 className="mt-5 font-display text-5xl lg:text-6xl text-ivory tracking-tight">
                            One ecosystem.<br />
                            <span className="italic text-gold-shimmer">Four ways</span> to use it.
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-ivory/60 leading-relaxed">
                        IndoBlitz is a digital services company and a talent ecosystem under one roof.
                        Hire us, train with us, partner with us - or all three.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-5">
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <motion.div
                                key={s.id}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                                className="glass glass-hover rounded-2xl p-8 lg:p-10 group"
                                data-testid={`service-${s.id}`}
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-mono text-xs uppercase tracking-widest text-gold/80">{s.eyebrow}</span>
                                    <div className="w-11 h-11 rounded-xl bg-gold/10 border border-gold/15 flex items-center justify-center">
                                        <Icon className="w-5 h-5 text-gold" />
                                    </div>
                                </div>
                                <h3 className="mt-6 font-display text-3xl text-ivory leading-tight">{s.title}</h3>
                                <p className="mt-3 text-ivory/65 leading-relaxed">{s.desc}</p>

                                <ul className="mt-7 grid grid-cols-2 gap-3">
                                    {s.bullets.map((b) => (
                                        <li key={b} className="flex items-start gap-2 text-sm text-ivory/80">
                                            <Check className="w-4 h-4 text-teal mt-0.5 shrink-0" />
                                            <span>{b}</span>
                                        </li>
                                    ))}
                                </ul>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Services;
